import { AVATAR_SIZES } from './consts'
import styles from './index.module.scss'

export function Avatar({ url, size = AVATAR_SIZES.md }) {
  return <img className={`${styles.avatar} ${styles[size]}`} src={url} alt="" />
}
